const rail = {
  rails: "Rails",
  senior: "Senior",
  seniors: "Seniors",
  youths: "Youths",
  yearOld: "year old",
  yearsOld: "years old",
};

export default rail;
